import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import userService from "../helpers/user.service";
import MensagemService from "../Services/Mensagem.service";
import Helper from "../helpers/helper.service";

export async function initPush(onTokenReceived) {

  // Verifica se a plataforma não é web
  if (Capacitor.getPlatform() !== 'web') {

    const modoAluno = (window.localStorage.getItem("idModoAluno")) ? true : false
    if(modoAluno)
      return

    try {

      // Solicita permissão para notificações push
      const { receive } = await PushNotifications.requestPermissions();

      if (receive === 'granted') {

        // IMPORTANTE: Adicionar listeners ANTES de registrar
        // No iOS, o evento pode ser disparado imediatamente após register()

        // Listener para o evento de registro bem-sucedido
        PushNotifications.addListener('registration', async (token) => {
          // console.log('📱 Evento registration recebido:', token);
          // alert('TOKEN: ' + token.value);
          const storedToken = localStorage.getItem('fcm_token_mobile')
          const isNewToken = storedToken !== token.value

          if (isNewToken && token.value) {
            // console.log('🎯 Novo Token Web FCM:', token.value)
            // alert('NOVO: ' + token.value);

            try {

              // Obtém o usuário logado
              const usuario = userService.getUser();
              if (!usuario || !usuario.IdUsuario) {
                throw new Error('Usuário não encontrado para salvar CFM token')
              }

              const data = {
                IdUsuario: usuario.IdUsuario,
                Token: token.value
              }

              const result = await MensagemService.gravarToken(data);
              if (!result.Success)
                throw new Error(Helper.getMessageError(result))

              // console.log("update token:", token.value)
              localStorage.setItem('fcm_token_mobile', token.value)

            } catch (error) {
              console.error('Erro ao atualizar CFM token: ', error);
            }

          } else {
            // alert('STORAGE TOKEN: ' + token.value);
            // console.log('✅ Token Web FCM já existe:', token.value)
          }

        });

        // Listener para erros de registro
        PushNotifications.addListener('registrationError', error => {
          console.error('Registration error:', error);
          swalAlert.fire('', 'Erro ao ativar as notificações push', 'warning');
        });

        // Registra para receber notificações push (DEPOIS de adicionar os listeners)
        // console.log('📱 Registrando push notifications...');
        await PushNotifications.register();
        // console.log('📱 PushNotifications.register() concluído');

        // No iOS, às vezes o evento pode demorar um pouco para disparar
        // Vamos aguardar um pouco e verificar se o token já está disponível
        setTimeout(async () => {
          try {
            // Tenta verificar se já temos um token registrado
            const storedToken = localStorage.getItem('fcm_token_mobile');
            if (!storedToken) {
              // console.log('📱 Aguardando token de registro...');
              // Se após 3 segundos ainda não tivermos token, pode ser um problema
              setTimeout(() => {
                const stillNoToken = !localStorage.getItem('fcm_token_mobile');
                if (stillNoToken) {
                  console.warn('📱 ⚠️ Token não recebido após 3 segundos. Verifique os logs do Xcode.');
                }
              }, 3000);
            }
          } catch (error) {
            console.error('📱 Erro ao verificar token:', error);
          }
        }, 500);

        // Listener para notificações recebidas em primeiro plano
        PushNotifications.addListener('pushNotificationReceived', notification => {
          console.info('Push notification received:', notification);

          const mensagem = notification.body.slice(0, 60);

          const url = new URL(notification.data.link);
          const rota = url.pathname + url.search;


          swalToast.fire({
            timer: 15000,
            html: `<a href="${rota}">Notificação: ${notification.title} - ${mensagem}</a>`,
            icon: 'info',
          });

        });

        // Listener para ações em notificações
        PushNotifications.addListener('pushNotificationActionPerformed', action => {
          // console.info('Push notification action performed:', action);
        });

      } else {
        // console.warn('Push notification permissions not granted.');
      }

    } catch (e) {
      // console.error('Error initializing Push Notifications:', e);
    }
  }
}
